import React, { useState, useEffect } from "react";
import logos from "./assets/TMC+logo.png";
import html2canvas from "html2canvas";
import Lottie from "react-lottie";

export default function SalahTimeTable({ salahTimes }) {
  const [nextPrayer, setNextPrayer] = useState(null);
  const [hoveredRow, setHoveredRow] = useState(null);

  const tableStyle = {
    width: "90%",
    fontSize: "1rem",
    fontFamily: "'Open Sans', sans-serif",
    borderCollapse: "collapse",
    marginTop: "30px",
    boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.5)",
    borderRadius: "15px",
    overflow: "hidden",
    backgroundColor: "#1c1c1e",
    color: "#f0f0f0",
  };

  const headerStyle = {
    background: "linear-gradient(135deg, #4b6cb7 0%, #182848 100%)",
    color: "black",
    padding: "20px",
    fontSize: "1.2rem",
    fontFamily: "'Smooch Sans', cursive",
    letterSpacing: "2px",
  };

  const rowStyle = {
    borderBottom: "1px solid #2a2a2e",
    padding: "15px",
    textAlign: "center",
    transition: "background-color 0.3s ease",
    cursor: "pointer",
  };

  const hoverStyle = {
    backgroundColor: "#3a3a3c",
  };

  const calculateCountdown = (prayerTime) => {
    const now = new Date();
    let targetTime = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      ...prayerTime
    );

    // Check if the target time is in the past (i.e., prayer time has already passed today)
    if (targetTime < now) {
      // Set target time to the same time on the next day
      targetTime.setDate(targetTime.getDate() + 1);
    }

    let diff = targetTime - now;

    // Convert difference to hours, minutes, and seconds
    const hours = Math.floor(diff / 3600000); // milliseconds to hours
    diff -= hours * 3600000;
    const minutes = Math.floor(diff / 60000); // milliseconds to minutes
    diff -= minutes * 60000;
    const seconds = Math.floor(diff / 1000); // milliseconds to seconds

    return { hours, minutes, seconds };
  };

  // find out when the next salah time is based on current time and the salah times
  function getNextSalah(currentHour, currentMinute, currentSecond, salahTimes) {
    const to24HourFormat = (timeString) => {
      // convert time string to 24 hour format, it is now like this "1:30 PM"
      const [time, period] = timeString.split(" ");
      const [hour, minute] = time.split(":");
      return period === "PM"
        ? [parseInt(hour) + 12, parseInt(minute)]
        : [parseInt(hour), parseInt(minute)];
    };

    const toSeconds = (hour, minute, second) =>
      hour * 3600 + minute * 60 + second;
    const currentSeconds = toSeconds(currentHour, currentMinute, currentSecond);

    const prayerTimes = [
      { name: "Dhuhr", time: to24HourFormat(salahTimes[0].dhuhr.msc) },
      { name: "Asr", time: to24HourFormat(salahTimes[0].asr.msc) },
      { name: "Maghrib", time: to24HourFormat(salahTimes[0].maghrib.msc) },
      { name: "Isha", time: to24HourFormat(salahTimes[0].isha.msc) },
    ];

    for (let i = 0; i < prayerTimes.length; i++) {
      const prayerSeconds = toSeconds(
        prayerTimes[i].time[0],
        prayerTimes[i].time[1],
        0
      );
      if (currentSeconds < prayerSeconds) {
        return prayerTimes[i].name;
      }
    }
    return "Dhuhr";
  }
  const [MSCCountDown, setMSCCountDown] = useState(null);
  const [LibraryCountDown, setLibraryCountDown] = useState(null);
  const to24HourFormat = (timeString) => {
    const [time, period] = timeString.split(" ");
    let [hour, minute] = time.split(":");
    hour = parseInt(hour);
    minute = parseInt(minute);

    if (period === "PM" && hour !== 12) {
      hour += 12;
    } else if (period === "AM" && hour === 12) {
      hour = 0;
    }

    return [hour, minute];
  };

  const handleDownload = async () => {
    const table = document.getElementById("myTable");

    const canvas = await html2canvas(table);
    const image = canvas.toDataURL("image/jpeg", 1.0);

    // Create a link and set the URL and download attributes
    const downloadLink = document.createElement("a");
    downloadLink.href = image;
    downloadLink.download = "table.jpg";

    // Append to the DOM, click it, and then remove it
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  // Example usage
  const nextSalah = () => {
    const currentTime = new Date();
    const currentHour = currentTime.getHours();
    const currentMinute = currentTime.getMinutes();
    const currentSecond = currentTime.getSeconds();

    const nextSalahTime = getNextSalah(
      currentHour,
      currentMinute,
      currentSecond,
      salahTimes
    );
    // console.log("Next Salah is:", nextSalahTime);
    setNextPrayer(nextSalahTime);
    // get the time left for the next salah at MSC and Library and set it to state MSCCountDown and LibraryCountDown
    const mscTime = salahTimes[0][nextSalahTime.toLowerCase()].msc;
    const libraryTime = salahTimes[0][nextSalahTime.toLowerCase()].library;

    const mscCountdown = calculateCountdown(to24HourFormat(mscTime));
    const libraryCountdown = calculateCountdown(to24HourFormat(libraryTime));

    setMSCCountDown(
      `${mscCountdown.hours}h ${mscCountdown.minutes}m ${mscCountdown.seconds}s`
    );
    setLibraryCountDown(
      `${libraryCountdown.hours}h ${libraryCountdown.minutes}m ${libraryCountdown.seconds}s`
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      salahTimes && nextSalah();
    }, 1000);

    return () => clearInterval(interval);
  }, [salahTimes]);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        borderRadius: "10px",
        fontFamily: "'Dosis', cursive",
      }}
    >
      {salahTimes && (
        <>
          {nextPrayer && (
            <h3
              style={{
                fontFamily: "'Dosis', cursive",
                color: "black",
                fontSize: "1.1rem",
                textAlign: "center",
                margin: "0 auto",
                maxWidth: "95%",
              }}
            >
              <style>
                {`
        @media (max-width: 600px) { /* Adjusts for screens smaller than 600px */
          .prayer-time {
            font-size: 1rem;
          }
        }
        @media (max-width: 400px) { /* Adjusts for screens smaller than 400px */
          .prayer-time {
            font-size: 1rem;
          }
        }
      `}
              </style>
              <div
                style={{
                  display: "grid",
                  gridTemplateRows: "auto auto",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <div className="prayer-time">Next Salah: {nextPrayer}</div>
                <div
                  className="prayer-time"
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                    flexWrap: "nowrap",
                    flexDirection: "column",
                  }}
                >
                  <span>
                    MSC: {salahTimes[0][nextPrayer.toLowerCase()].msc} (in{" "}
                    {MSCCountDown})
                  </span>
                  <span>
                    Library: {salahTimes[0][nextPrayer.toLowerCase()].library}{" "}
                    (in {LibraryCountDown})
                  </span>
                </div>
              </div>
            </h3>
          )}

          <table style={tableStyle} id="myTable">
            <thead>
              <tr>
                <th style={headerStyle}>Salah</th>
                <th style={headerStyle}>Time</th>
                <th style={headerStyle}>Location</th>
              </tr>
            </thead>
            <tbody>
              <tr
                style={
                  hoveredRow === "dhuhr"
                    ? { ...rowStyle, ...hoverStyle }
                    : rowStyle
                }
                onMouseEnter={() => setHoveredRow("dhuhr")}
                onMouseLeave={() => setHoveredRow(null)}
              >
                <td>Dhuhr</td>
                <td>{salahTimes[0].dhuhr.msc}</td>
                <td>MSC</td>
              </tr>
              <tr
                style={
                  hoveredRow === "dhuhr"
                    ? { ...rowStyle, ...hoverStyle }
                    : rowStyle
                }
                onMouseEnter={() => setHoveredRow("dhuhr")}
                onMouseLeave={() => setHoveredRow(null)}
              >
                <td></td>
                <td>{salahTimes[0].dhuhr.library}</td>
                <td>Library</td>
              </tr>
              <tr
                style={
                  hoveredRow === "asr"
                    ? { ...rowStyle, ...hoverStyle }
                    : rowStyle
                }
                onMouseEnter={() => setHoveredRow("asr")}
                onMouseLeave={() => setHoveredRow(null)}
              >
                <td>Asr</td>
                <td>{salahTimes[0].asr.msc}</td>
                <td>MSC</td>
              </tr>
              <tr
                style={
                  hoveredRow === "asr"
                    ? { ...rowStyle, ...hoverStyle }
                    : rowStyle
                }
                onMouseEnter={() => setHoveredRow("asr")}
                onMouseLeave={() => setHoveredRow(null)}
              >
                <td></td>
                <td>{salahTimes[0].asr.library}</td>
                <td>Library</td>
              </tr>
              <tr
                style={
                  hoveredRow === "maghrib"
                    ? { ...rowStyle, ...hoverStyle }
                    : rowStyle
                }
                onMouseEnter={() => setHoveredRow("maghrib")}
                onMouseLeave={() => setHoveredRow(null)}
              >
                <td>Maghrib</td>
                <td>{salahTimes[0].maghrib.msc}</td>
                <td>MSC</td>
              </tr>
              <tr
                style={
                  hoveredRow === "maghrib"
                    ? { ...rowStyle, ...hoverStyle }
                    : rowStyle
                }
                onMouseEnter={() => setHoveredRow("maghrib")}
                onMouseLeave={() => setHoveredRow(null)}
              >
                <td></td>
                <td>{salahTimes[0].maghrib.library}</td>
                <td>Library</td>
              </tr>
              <tr
                style={
                  hoveredRow === "isha"
                    ? { ...rowStyle, ...hoverStyle }
                    : rowStyle
                }
                onMouseEnter={() => setHoveredRow("isha")}
                onMouseLeave={() => setHoveredRow(null)}
              >
                <td>Isha</td>
                <td>{salahTimes[0].isha.msc}</td>
                <td>MSC</td>
              </tr>
              <tr
                style={
                  hoveredRow === "isha"
                    ? { ...rowStyle, ...hoverStyle }
                    : rowStyle
                }
                onMouseEnter={() => setHoveredRow("isha")}
                onMouseLeave={() => setHoveredRow(null)}
              >
                <td></td>
                <td>{salahTimes[0].isha.library}</td>
                <td>Library</td>
              </tr>
            </tbody>
          </table>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "20px",
              backgroundColor: "#1c1c1e",
              padding: "20px",
              width: "100%",
            }}
          >
            <div>
              <h3
                style={{
                  fontFamily: "'Dosis', cursive",
                  color: "white",
                  fontSize: "1.5rem",
                  textAlign: "center",
                  margin: "0 auto",
                  maxWidth: "95%",
                }}
              >
                SAVE THE SCHEDULE ON YOUR DEVICE
              </h3>
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: require("./assets/animation.json"),
                }}
                height={250}
                width={250}
              />
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <button
                style={{
                  padding: "10px",
                  margin: "10px",
                  backgroundColor: "#4b6cb7",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  fontSize: "1rem",
                  fontFamily: "'Open Sans', sans-serif",
                  letterSpacing: "1px",
                  boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.5)",
                }}
                onClick={handleDownload}
              >
                Click here to download
              </button>
              <p
                style={{
                  fontFamily: "'Dosis', cursive",
                  color: "white",
                  fontSize: "1.1rem",
                  textAlign: "center",
                  margin: "0 auto",
                  maxWidth: "95%",
                }}
              >
                Please note that the schedule is updated every two weeks. So
                make sure to check back for the latest schedule.
              </p>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
